export enum ImageEngineEnum {
  GPT_IMAGE_2 = 1,
  RECRAFT_V3 = 2,
}
